// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".result-counter-counter {\n  font-family: \"urbane\", sans-serif;\n  font-weight: 500;\n  font-style: normal;\n  font-size: 2rem;\n}\n\n.result-counter-counter > .count {\n  font-weight: 700;\n  font-size: 3rem;\n}\n", ""]);
// Exports
module.exports = exports;
